import React from 'react';
import { useTranslation } from 'react-i18next';
import OInput from '../../../UI/FormControls/OInput';
import OAutocomplete from '../../../UI/MuiAutocomplete';

const Inputs = ({ formValues, setFormValues, masine }) => {
  const { t, i18n } = useTranslation();
  const handleChange = (item) => {
    setFormValues((curr) => {
      return { ...curr, [item.target.name]: item.target.value };
    });
  };
  const handleClickMasina = (item) => {
    setFormValues((curr) => {
      return {
        ...curr,
        idTipaMasine: item.id,
        nazivTipaMasine: item.vrednost,
      };
    });
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '2px',
        marginBottom: '10px',
      }}
    >
      <OInput
        label="Naziv *"
        name="naziv"
        value={formValues.naziv}
        handleChange={handleChange}
        touched={formValues.touchedNaziv}
        setTouched={() => {
          setFormValues((curr) => {
            return { ...curr, touchedNaziv: true };
          });
        }}
        errorMessage={`Naziv  ${t('isRequired')}`}
        // style={{ width: '100%' }}
      />
      <OAutocomplete
        data={masine}
        value={formValues.nazivTipaMasine || ''}
        handleClick={handleClickMasina}
        label="Tip mašine"
        style={{ width: '250px' }}
      />

      <OInput
        label="Opis"
        name="opis"
        value={formValues.opis}
        handleChange={handleChange}
      />
    </div>
  );
};

export default Inputs;
